import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import CampCategoryCreateEditForm from './Components/CampCategoryCreateEditForm';
import CampCategoryApi from './CampCategoryApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: CampCategoryCreateEditForm,
                getCreate: CampCategoryApi.create,
                defaults: {},
                successMessage: "CampCategory Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}